import React from 'react'
import Header from "../../components/header";
import Footer from "../../components/footer";
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { NavLink } from "react-router-dom";



class Register extends React.Component {

    render() {

        return (

            <>


                <div className="registration-wrapper">

                    <Header  routes={[{"name" : "Registration", "route" : "/Register"}]} />
                    <div className="register-content">
                        <div className="container">
                            <div className="register-patient">
                                <ul>
                                    <li>
                                        <NavLink to="/PatientReg" >
                                            <h1>I Am a Patient Requesting Records</h1>
                                            <div className="imgblock1 bgimgpatient"></div>
                                            <span className="checkimg">
                                                <img src="images/check-symbol.png" />
                                            </span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/OtherReg" > 
                                            <h1>I Am a Third Party Requestor</h1>
                                            <div className="imgblock2 bgimgpatient"></div>
                                            <span className="checkimg">
                                                <img src="images/check-symbol.png" />
                                            </span>
                                        </NavLink>
                                    </li>
                                    <li>
                                    <NavLink to="/FacilityReg" >
                                        
                                            <h1>I Am a Practice/Doctor and Want to Enroll in ePaper Road</h1>
                                            <div className="imgblock3 bgimgpatient"></div>
                                            <span className="checkimg">
                                                <img src="images/check-symbol.png" />
                                            </span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <div className="goto-login"  onClick={() => { this.props.history.push("./login") }}>

                                            <button className="loginbttn" type="button"
                                                >
                                                Go to Login
                                             </button>
                                            <span>
                                                <img src="images/right-arrow.png" />
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <Footer />
                </div>

            </>
        )
    }
}

export default withRouter(Register);